/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["cv",[["AM","PM"]],u,[["В","Т","Ы","Ю","К","Э","Ш"],["выр.","тун.","ытл.","юн.","кӗҫ.","эр.","шӑм."],["вырсарникун","тунтикун","ытларикун","юнкун","кӗҫнерникун","эрнекун","шӑматкун"],["выр.","тун.","ытл.","юн.","кӗҫ.","эр.","шӑм."]],u,[["К","Н","П","А","Ҫ","Ҫ","У","Ҫ","А","Ю","Ч","Р"],["кӑр.","нар.","пуш","ака","ҫу","ҫӗр.","утӑ","ҫур.","авӑн","юпа","чӳк","раш."],["кӑрлач","нарӑс","пуш","ака","ҫу","ҫӗртме","утӑ","ҫурла","авӑн","юпа","чӳк","раштав"]],u,[["п. э.","х. э."],u,["Христос ҫуралнӑ кунччен","Христос ҫуралнӑ кунран"]],1,[6,0],["dd.MM.y","d MMM y 'ҫ'.","d MMMM y 'ҫ'.","EEEE, d MMMM y 'ҫ'."],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1}, {0}",u,u,u],[","," ",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0 %","#,##0.00 ¤","#E0"],"RUB","₽","Раҫҫей тенкӗ",{"JPY":["JP¥","¥"],"RUB":["₽"]},"ltr", plural];
